import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { RouterModule } from '@angular/router';
import { DialogConfirmComponent } from './components/dialog/dialog-confirm/dialog-confirm.component';
import { DialogAlertComponent } from './components/dialog/dialog-alert/dialog-alert.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubNavigationComponent } from './components/sub-navigation/sub-navigation.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { HeaderComponent } from './components/header/header.component';
import { BottomSheetContactComponent } from './components/bottom-sheet/bottom-sheet-contact/bottom-sheet-contact.component';
import { ReplaceNewLinePipe } from './pipes/replace-new-line.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { teamSelectionTypePipe } from './pipes/team-selection-type.pipe';
import { EmployeeCodeTrim } from './pipes/employee-code-trim.pipe';
import { StringLimited50 } from './pipes/string-limited-50.pipe';
import { PadPipe } from './pipes/pad-pipe';
import { IsinroleDirective } from './directive/isinrole.directive';
import { FullStatusPipe } from './pipes/full-status.pipe';
import { SoTextsComponent } from './components/bottom-sheet/so-texts/so-texts.component';
import { FilterlistTypePipe } from './pipes/filterlist-type.pipe';
import { TeamTypePipe } from './pipes/team-type.pipe';
import { ClickOutsideDirective } from './directive/click-outside.directive';
import { TextIsTruncatedDirective } from './directive/text-is-truncated.directive';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { SoShortStatusTransformPipe } from './pipes/so-short-status-transform.pipe';

@NgModule({
  declarations: [
    DialogAlertComponent, 
    DialogConfirmComponent,
    SubNavigationComponent,
    PageNotFoundComponent,
    HeaderComponent,
    BottomSheetContactComponent,
    ReplaceNewLinePipe,
    YesNoPipe,
    teamSelectionTypePipe,
    StringLimited50,
    PadPipe,
    IsinroleDirective,
    FullStatusPipe,
    SoTextsComponent,
    FilterlistTypePipe,
    TeamTypePipe,
    ClickOutsideDirective,
    TextIsTruncatedDirective,
    SoShortStatusTransformPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    EmployeeCodeTrim,
    MessageBoxComponent
  ],
  exports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DialogConfirmComponent,
    SubNavigationComponent,
    PageNotFoundComponent,
    HeaderComponent,
    BottomSheetContactComponent,
    ReplaceNewLinePipe,
    YesNoPipe,
    teamSelectionTypePipe,
    EmployeeCodeTrim,
    StringLimited50,
    PadPipe,
    IsinroleDirective,
    FullStatusPipe,
    SoTextsComponent,
    FilterlistTypePipe,
    TeamTypePipe,
    ClickOutsideDirective,
    TextIsTruncatedDirective,
    CommonModule,
    MessageBoxComponent,
    SoShortStatusTransformPipe
  ]
})
export class SharedModule { }
